import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEffect, useState, useRef } from 'react';
import styled from '@xstyled/styled-components';
import { InputNumber, notification, Space } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { styleVariables, getColor } from '@lib/common';
import { SubmissionScore } from '@module/assignment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledInputNumberContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 5px;\n  border: 1px solid ", ";\n  padding: 4px 8px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"])), styleVariables.colors.gray10);
var StyledActionButton = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  border: 1px solid\n    ", ";\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  padding: 0;\n\n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n    opacity: 0.8;\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"])), function (props) {
  return props.variant === 'submit' ? getColor('fillIntActive')({
    theme: props.theme
  }) : styleVariables.colors.gray10;
}, function (props) {
  return props.variant === 'submit' ? getColor('fillIntActive')({
    theme: props.theme
  }) : 'white';
}, function (props) {
  return props.variant === 'submit' ? 'white' : styleVariables.colors.gray10;
}, function (props) {
  return props.variant === 'submit' ? getColor('fillIntActive')({
    theme: props.theme
  }) : styleVariables.colors.gray1;
}, function (props) {
  return props.variant === 'submit' ? getColor('fillIntActive')({
    theme: props.theme
  }) : styleVariables.colors.gray9;
});
var StyledCloseIcon = styled(CloseOutlined)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 12px;\n"])));
var StyledCheckIcon = styled(CheckOutlined)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 12px;\n"])));
var StyledInputNumber = styled(InputNumber)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: 'white';\n\n  .ant-input-number {\n    width: 40px;\n    height: 35px;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    font-size: ", ";\n    font-weight: ", ";\n  }\n\n  .ant-input-number-input {\n    text-align: center;\n    font-size: 14px;\n    padding: 0;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .ant-input-number-group-addon {\n    min-width: 73px;\n    background-color: 'white';\n    border-color: transparent;\n    color: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    padding-left: 0;\n    padding-right: 7px;\n  }\n\n  .ant-input-number-disabled {\n    background-color: 'white';\n  }\n"])), function (props) {
  var isInvalid = props.isInvalid;

  if (isInvalid) {
    return styleVariables.colors.red3;
  }
}, styleVariables.font.fontSizeOriginal, styleVariables.font.fontWeightStrong, styleVariables.colors.gray10, styleVariables.font.fontWeightStrong, styleVariables.font.fontSizeSupport);
export var ScoreInput = function ScoreInput(props) {
  var questionScore = props.questionScore,
      label = props.label,
      submitScore = props.submitScore,
      disabled = props.disabled,
      score = props.value,
      active = props.active,
      danger = props.danger;

  var _useState = useState(false),
      isInvalidScore = _useState[0],
      setIsInvalidScore = _useState[1];

  var _useState2 = useState(false),
      isFocus = _useState2[0],
      setIsFocus = _useState2[1];

  var _useState3 = useState(score),
      value = _useState3[0],
      setValue = _useState3[1];

  useEffect(function () {
    setValue(score);
  }, [score]);
  var inputRef = useRef(null);

  var handleCancel = function handleCancel() {
    var _inputRef$current;

    setValue(score === SubmissionScore["default"].value ? null : score);
    setIsInvalidScore(false);
    setIsFocus(false);
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.blur();
  };

  var handleSubmit = function handleSubmit() {
    var _inputRef$current2;

    var inputValue = Number(value);
    var isInvalidScore = value === undefined || value === null || value === '' || inputValue < 0 || questionScore < inputValue || isNaN(inputValue);
    console.log('handleSubmit - current value:', value);
    console.log('handleSubmit - inputValue:', inputValue);
    console.log('handleSubmit - score prop:', score);
    console.log('handleSubmit - questionScore:', questionScore);
    console.log('handleSubmit - isInvalidScore:', isInvalidScore);

    if (isInvalidScore) {
      console.log('handleSubmit - Invalid score detected, showing error'); // Show error toast for any invalid score

      notification.error({
        message: 'Invalid Score',
        description: "Score must be between 0 and ".concat(questionScore, " points."),
        duration: 3
      });
      setIsInvalidScore(true);
      return;
    }

    console.log('handleSubmit - Valid score, calling submitScore with:', inputValue);
    setIsInvalidScore(false);
    setIsFocus(false);
    (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.blur(); // Always submit the score to ensure it updates

    submitScore(inputValue);
  };

  var isScored = value !== undefined && value !== null && value !== SubmissionScore["default"].value;
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: '6px'
    },
    children: [/*#__PURE__*/_jsx(StyledInputNumberContainer, {
      isInvalid: isInvalidScore,
      disabled: disabled,
      active: active,
      danger: danger,
      children: /*#__PURE__*/_jsx(StyledInputNumber, _objectSpread(_objectSpread({
        ref: inputRef,
        size: "small",
        addonAfter: "/".concat(questionScore, " ").concat(label.score),
        bordered: false,
        controls: false,
        isInvalid: isInvalidScore
      }, props), {}, {
        onFocus: function onFocus() {
          return setIsFocus(true);
        },
        onChange: function onChange(newValue) {
          return setValue(newValue);
        },
        onPressEnter: handleSubmit,
        isFocus: isFocus,
        value: isScored ? value : undefined,
        danger: danger,
        placeholder: isScored ? undefined : '-'
      }))
    }), isFocus && !disabled && /*#__PURE__*/_jsxs(Space, {
      size: 6,
      children: [/*#__PURE__*/_jsx(StyledActionButton, {
        variant: "cancel",
        onClick: handleCancel,
        children: /*#__PURE__*/_jsx(StyledCloseIcon, {})
      }), /*#__PURE__*/_jsx(StyledActionButton, {
        variant: "submit",
        onClick: handleSubmit,
        children: /*#__PURE__*/_jsx(StyledCheckIcon, {})
      })]
    })]
  });
};